module.exports = __webpack_public_path__ + "img/icon_1.e56f0738.png";